export default function QuickView(props) {

  const self = {
    matches: (subscription, user, title) => {
      return !self.flags(subscription, user, title).length
    },
    flags: (subscription, user, title) => {
      const result = []
      // if (props.product_skus && props.product_skus.length && props.product_skus.indexOf(subscription.sku) == -1) {
      //   result.push('not_within_product_skus')
      // }
      //
      // if (props.registered_after && new Date(props.registered_after) > new Date(subscription.startAt)) {
      //   result.push('before_registered_after')
      // }
      //
      const isStudent = subscription.enrollment && subscription.enrollment.ownedByOther(user)
      if (isStudent && self.isParent) {
        result.push('parent_role_for_student')
      }

      if (!isStudent && self.isStudent) {
        result.push('student_role_for_parent')
      }

      if (title != props.title) {
        result.push('title_not_match')
      }

      return result
    },
    isParent: props.role == 'parent',
    isStudent: props.role == 'student',
    isSmall: props.size == 'small',
    isMiddle: props.size == 'middle',
    isLarge: props.size == 'large'
  }
  return Object.assign({}, props, self)
}
